// extracted by mini-css-extract-plugin
export default {"content":"swa-z","title":"twa-z","subTitle":"uwa-z","banner":"vwa-z","productCardOverride":"wwa-z"};